/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { InsightsDriverBreakdownOvertimeDtoModel, InsightsDriverBreakdownOvertimeDtoModelType } from "./InsightsDriverBreakdownOvertimeDtoModel"
import { InsightsDriverBreakdownOvertimeDtoModelSelector } from "./InsightsDriverBreakdownOvertimeDtoModel.base"
import { RootStoreType } from "./index"


/**
 * InsightsDriverBreakdownOvertimeDtoEdgeBase
 * auto generated base class for the model InsightsDriverBreakdownOvertimeDtoEdgeModel.
 */
export const InsightsDriverBreakdownOvertimeDtoEdgeModelBase = ModelBase
  .named('InsightsDriverBreakdownOvertimeDtoEdge')
  .props({
    __typename: types.optional(types.literal("InsightsDriverBreakdownOvertimeDtoEdge"), "InsightsDriverBreakdownOvertimeDtoEdge"),
    cursor: types.union(types.undefined, types.string),
    node: types.union(types.undefined, types.late((): any => InsightsDriverBreakdownOvertimeDtoModel)),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class InsightsDriverBreakdownOvertimeDtoEdgeModelSelector extends QueryBuilder {
  get cursor() { return this.__attr(`cursor`) }
  node(builder: string | InsightsDriverBreakdownOvertimeDtoModelSelector | ((selector: InsightsDriverBreakdownOvertimeDtoModelSelector) => InsightsDriverBreakdownOvertimeDtoModelSelector) | undefined) { return this.__child(`node`, InsightsDriverBreakdownOvertimeDtoModelSelector, builder) }
}
export function selectFromInsightsDriverBreakdownOvertimeDtoEdge() {
  return new InsightsDriverBreakdownOvertimeDtoEdgeModelSelector()
}

export const insightsDriverBreakdownOvertimeDtoEdgeModelPrimitives = selectFromInsightsDriverBreakdownOvertimeDtoEdge().cursor
